import { useEffect, useState } from "react";
import { t } from "@lingui/core/macro";

import { Icon } from "_/components/icon";
import { useChannels } from "_/data/channels";
import { useBuildsets, useBuildsetsPage } from "_/data/buildsets";
import { useDebounce } from "_/hooks/useDebounce";
import { TablePagination } from "_/components/table";

import { ChannelsTable } from "./channelsTable";
import { BuildsetsTable } from "./buildsetsTable";
import { AdminPage } from "../admin-page";

import * as S from "../styled";

export const Software = () => {
  const [buildsetsSearch, setBuildsetsSearch] = useState("");
  const debouncedBuildsetsSearch = useDebounce(buildsetsSearch, 300);
  const { data: channels = [], isLoading: channelsLoading } = useChannels();
  const { data: buildsets = [], isLoading: buildsetsLoading } = useBuildsets();
  const buildsetsPage = useBuildsetsPage(debouncedBuildsetsSearch);
  const { reset: resetBuildsetsPage } = buildsetsPage;

  useEffect(() => {
    resetBuildsetsPage();
  }, [debouncedBuildsetsSearch, resetBuildsetsPage]);

  return (
    <AdminPage title={t`common.software`}>
      <S.AdminContentSection>
        <S.AdminContentSectionTitleContainer>
          <h2>{t`common.channels`}</h2>
        </S.AdminContentSectionTitleContainer>
        <ChannelsTable
          channels={channels}
          buildsets={buildsets}
          isLoading={channelsLoading || buildsetsLoading}
        />
      </S.AdminContentSection>

      <S.AdminContentSection>
        <S.AdminContentSectionTitleContainer>
          <h2>{t`common.buildsets`}</h2>
          <S.SearchField
            aria-label={t`common.search`}
            iconLeft={<Icon variant="Search" />}
            value={buildsetsSearch}
            onChange={setBuildsetsSearch}
          />
        </S.AdminContentSectionTitleContainer>
        <BuildsetsTable
          buildsets={buildsetsPage.data?.items ?? []}
          channels={channels}
          isLoading={buildsetsPage.isLoading}
        />
        <TablePagination pagination={buildsetsPage} />
      </S.AdminContentSection>
    </AdminPage>
  );
};
